import globals from "@/styles/partials/global-variables";
import { NormalText } from "../partials/texts";

export default {
  container: {
    ...NormalText,
    alignItems: "flex-start",
    marginBottom: "15px",
    position: "relative",
    textAlign: "left",
    "&.has-image": {
      "& .answer-content": {
        borderTop: "0px"
      }
    },
    "&:focus": {
      outline: "none"
    },
    "&.is-selected": {
      "& .input-element": {
        "&:after": {
          content: "''",
          display: "block",
          position: "absolute",
          top: "0",
          bottom: "0",
          left: "0",
          right: "0",
          margin: "auto",
          height: "12px",
          width: "12px",
          backgroundColor: globals.colors.blue,
          borderRadius: "50%"
        }
      }
    },
    "& label": {
      "& .answer-image": {
        "& .image-element": {
          width: "100%",
          height: "260px",
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "block",
          border: "1px solid black",
          borderBottom: "0px"
        },
        "&:hover": {
          cursor: "pointer"
        }
      },
      "& .answer-content": {
        position: "relative",
        border: "1px solid black",
        padding: "15px",
        "&:hover": {
          cursor: "pointer"
        },
        "& .input-element": {
          display: "inline-block",
          height: "20px",
          width: "20px",
          position: "absolute",
          top: "16px",
          left: "18px",
          borderRadius: "50%",
          boxShadow: "0 1px 2px 0 rgba(0,0,0,.1)",
          backgroundColor: "#f2f2f2",
          backgroundImage: "none!important"
        },
        "& .answer-text": {
          paddingLeft: "12px"
        }
      }
    },
    "& .info-text": {
      padding: "8px 0",
      color: globals.colors.gray4
    }
  }
};
